import { useEffect, useReducer } from 'react';
import { useSelector } from 'react-redux';
// import { useSelector } from 'react-redux';

import ConversationButton from './ConversationButton';

export const ACTIONS = {
  TOGGLE_BUTTON: 'toggle-button',
  COMPLETE_BUTTON: 'complete-button',
  TOGGLE_PLAY: 'toggle-play',
};

function reducer(buttons, action) {
  switch (action.type) {
    case ACTIONS.TOGGLE_BUTTON: {
      let activeButtonMarker = '';
      let buttons_copy = buttons.map((button) => {
        let originalButtonsOrder = [...buttons];

        //Get the non random order
        originalButtonsOrder.sort(function (a, b) {
          let keyA = a.id,
            keyB = b.id;
          // Compare the 2 keys
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });

        //only run check against original order for the clicked button
        if (button.id === action.payload.id) {
          //Check if previous button in original order has been toggled
          //Stops people clicking lesson 1 buttons in wrong order
          if (button.id - 1 >= 0) {
            if (originalButtonsOrder[button.id - 1].complete === false) {
              return { ...button, error: true };
            }
          }

          for (let i = 0; i < originalButtonsOrder.length; i++) {
            //does id match payload id?
            if (originalButtonsOrder[i].id === action.payload.id) {
              //success! User has clicked button in correct order
              //spread out button and update toggled prop
              let activeButton = {
                ...button,
                toggled: !button.toggled,
                complete: false,
              };

              //Now find all inactive buttons
              let inactiveButtons = buttons.filter((e) => e.id !== button.id);

              //If there are inactive buttons we need to set the marker
              if (inactiveButtons.length > 0 && activeButton.toggled === true) {
                activeButtonMarker = button.id;
              }

              //return the new state of active button
              return activeButton;
            }
          }
        }

        //Return button unmodified if not equal to payload id
        return { ...button, error: false };
      });

      //Handle logic to deactivate none toggled buttons
      let inactiveButtonsSet = buttons_copy.map((button) => {
        if (
          button.toggled === false &&
          button.id !== activeButtonMarker &&
          activeButtonMarker !== ''
        ) {
          return { ...button, active: false, complete: false };
        } else {
          return { ...button, active: true };
        }
      });

      return inactiveButtonsSet;
    }
    case ACTIONS.COMPLETE_BUTTON:
      return buttons.map((button) => {
        if (button.id === action.payload.id && button.complete === false) {
          return { ...button, active: false, complete: true };
        }

        return { ...button, active: true };
      });
    case ACTIONS.TOGGLE_PLAY:
      return buttons.map((button) => {
        let originalButtonsOrder = [...buttons];

        //Get the non random order
        originalButtonsOrder.sort(function (a, b) {
          let keyA = a.id,
            keyB = b.id;
          // Compare the 2 keys
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });

        //only run check against original order for the clicked button
        if (button.id === action.payload.id) {
          if (button.complete === false) {
            return { ...button, played: true };
          }
        }

        return { ...button, played: false };
      });
    default:
      return { ...buttons };
  }
}

const ConversationParts = (props) => {
  const lesson = useSelector((state) => state.currentLesson);
  const sentenceNumber = props.sentenceNumber;

  const renderContent = (order) => {
    let orderedContent = [];

    for (let j = 0; j < order.length; j++) {
      let newObj = props.splits[order[j]];
      newObj.id = order[j];
      newObj.complete = false;
      newObj.error = false;
      newObj.duration = 1.5;
      newObj.played = false;
      newObj.toggled = false;
      newObj.active = true;
      orderedContent.push(newObj);
    }

    return orderedContent;
  };

  const [buttons, dispatch] = useReducer(reducer, renderContent(props.order));

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      let originalButtonsOrder = [...buttons];

      // Get the non random order
      originalButtonsOrder.sort(function (a, b) {
        let keyA = a.id,
          keyB = b.id;
        // Compare the 2 keys
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });

      let allCompleted = originalButtonsOrder.every((obj) => {
        return obj.complete === true;
      });

      if (allCompleted) {
        if (parseInt(lesson) === 1) {
          props.setShowFullConversation(true);
        }

        if (parseInt(lesson) === 2) {
          document
            .getElementById('button_audio_player')
            .addEventListener('ended', props.setAllButtonsChecked(true));
        }
      } else {
        props.setAllButtonsChecked(false);
        if (parseInt(lesson) === 2) {
          document
            .getElementById('button_audio_player')
            .removeEventListener('ended', props.setAllButtonsChecked(false));
        }
      }
    }

    return () => {
      mounted = false;
    };
  }, [buttons]);

  return (
    <div className="conversation-parts">
      {buttons.map((data, index) => (
        <ConversationButton
          key={`${index}`}
          buttonKey={`${index}`}
          id={`${index}`}
          buttonData={data}
          complete={false}
          dispatch={dispatch}
          sentenceNumber={sentenceNumber}
          conversationIndex={props.index}
          allButtons={buttons}
        />
      ))}
    </div>
  );
};

export default ConversationParts;
